import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
// import "../Style/customer_v2.scss";

//API
import ItemService from "../../../../../services/customer_appCommonService";
// import ItemServiceV2 from "../../../../../services/customer_v2_appCommonService";
import logistics from '../../../../../services/logistics_appCommonService';

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../../Components/formElements/ComboboxField";
// import { ComboboxFieldSubArray } from "../../../../Components/formElements/ComboboxFieldSubArray";
// import DataTable from "react-data-table-component";
import Constants from "../../../../../common/SupplierConstants";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
import {
  validateName,
  // validateRequired,
  validPostalCode,
} from "../../../../../common/Validations";
// import CustomerConstants from "../../../../../common/CustomerConstants";
import toast from "react-hot-toast";
// import GoogleMapComponent from "../../../Common/GoogleMapComponent";
import FileUploadComponent from "../../../../../Components/formElements/FileUploadComponent";
// import { saveCustomerRegData } from "../../../../redux/feature/customer_app/customerV1Slice";
import Layout from "../../../../../Layout/Layout";
import FileViewerModal from "../../../../../Components/FileViewer/FileViewerModal";
import CommonFillter from "../../../../../Components/Filter/Supplier/SupplierCommonFillter";
// import { ComboboxFieldSubArray } from "../../../../../Components/formElements/ComboboxFieldSubArray";
import LogisticsConstants from "../../../../../common/LogisticsConstants";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const TransporterRegistration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Transporter");

  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data);

  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  // const getCustomer = [
  //   { id: 1, name: "Yes" },
  //   { id: 2, name: "No" },
  // ];

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // const SalesOfficerData = [
  //   { id: 4, code: "A000", name: "Amarendra" },
  //   { id: 1, code: "S0001", name: "Manjunatha" },
  //   { id: 2, code: "S0002", name: "Umesh" },
  //   { id: 3, code: "S0003", name: "Amith" },
  //   { id: 4, code: "S0004", name: "Sathish" },
  // ];
  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [getErrorFields, /*setErrorFields*/] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const [getdocumentType, setdocumentType] = useState([]);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [validation, setValidation] = useState({
    organisationName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });

  // ADD new projects
  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "Document 1",
        documentType: "",
        certificateCode: "29AADCN1012B1Z6",
        stageDocument: "",
      },
    ],
    getLocations: [],
  };

  const [getProjectDetails, /*setProjectDetails*/] = useState([newProject]);

  //bank state
  const [getBankDetails, setBankDetails] = useState([]);

  const [getBankDetailsData, setBankDetailsData] = useState([]);

  const [getCompanyCode, setCompanyCode] = useState([]);
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "organisationName" ? value : "")
      ? (errors.organisationName = "")
      : (errors.organisationName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  //inputchange for companyprofile

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    organisationName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",

    version: "v0",
    status: "Registered",
    category: "VENDOR",

    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerCode: "",
    salesOfficerName: "",

    plantAddress: appConfig?.customerPlantAddress,
    projectLocation: "",

    customerTypeCode: "T01",
    customerTypeDesc: "Domestic",
    activeInactive:true
  });
  const [disabled, setDisabled] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [getCompanyProfile, setCompanyProfile] = useState({
    customerCode: "",
    typeOfCompany: "",
    typeOfFirm: "",
    creditLimit: "",
    creditLimitINR: "",
    typeOfCustomerSegment: "",
    creditPeriodDays: "",
    numberOfYearsInBusiness: "",
    security: "",
    detailsOfSecurity: "",
    paymentType: "",
  });
  // console.log(">>formInputs", formInputs);
  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // console.log(">> formInputs", formInputs);

  // SAVE
  const handleSave = async () => {
    // const requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    // if (!validateRequired(formInputs.organisationName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     organisationName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address2)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address2: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.city)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     city: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.cityPostalCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.distance)) {
    //   requiredFields.push(`${message.GET_MAP_DISTANCE}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   // setValidation((prev) => ({
    //   //   ...prev,
    //   //   cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   // }));
    //   return;
    // }
    // if (!validateRequired(formInputs.salesOfficerName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     salesOfficerName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.routeNumber)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     routeNumber: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    formInputs.firstName = formInputs.organisationName;
    formInputs.contactDetails = getcustomerContactPerson;
    formInputs.certifications = getDocumentTypeData;
    formInputs.projectDetails = getProjectDetails;
    formInputs.salesOfficerCode = userData?.userId;
    formInputs.salesOfficerName = userData?.firstName;
    // formInputs.routeDetails = getRouteDetails;
    formInputs.bandkDetails = getBankDetails;

    formInputs.companyProfile = getCompanyProfile;

    formInputs.financialTurnover = getFinancialTurnover;

    const obj = {
      data: formInputs,
    };
    console.log(">>obj", obj);
    setDisabled(true);
    await logistics.addTransporter(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        // dispatch(saveCustomerRegData(item?.data));
        navigate(LogisticsConstants.LOGISTICS_MASTER_TRANSPORTER_LIST);

        // console.log(">> userData");

        // if(userData){
        //   navigate(CustomerConstants.CUSTOMER_V1_COSTING_SHEET);
        //   dispatch(saveCustomerRegData(item?.data));
        // }else{
        //   navigate(CustomerConstants.CUSTOMER_V1_COSTING_SHEET_LOGIN);
        //   dispatch(saveCustomerRegData(item?.data));
        // }
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
    let obj4 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterDataSelf(obj4).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };

  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  const handleChangeCustomerContacts = (id, fieldName, value) => {
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  /* --------------------- Contact Person Inside Project Details -------- */

  //Add Projects
  //Delete Project

  //Project Contact Inputs
  //Dropdown
  /* ---------------------project Certifications  -------- */
  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };

  //document upload for projects
  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //bank start

  const bankInfoInitialData = {
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
  };

  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setBankDetailsData(item?.data);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };
  useEffect(() => {
    getBankMasterData(); // Load Bank Details
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Bank Info Section
  // const addBankForm = () => {
  //   setBankDetails([...getBankDetails, bankInfoInitialData]); // Add an empty object to the forms array
  // };

  // const removeBankForm = (indexToRemove) => {
  //   setBankDetails(
  //     getBankDetails.filter((form, index) => index !== indexToRemove)
  //   );
  // };

  useEffect(() => {
    setBankDetails([...getBankDetails, bankInfoInitialData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeBankInfo = (index, key, value) => {
    if (value) {
      const newForms = [...getBankDetails];
      newForms[index][key] = value;
      setBankDetails(newForms);

      if (value.length < 6 || value.length > 18) {
      }

      if (key === "bankKey") {
        // eslint-disable-next-line array-callback-return
        getBankDetailsData.filter((item) => {
          if (item.name === value) {
            const newForms = [...getBankDetails];
            newForms[index]["bankCountryDescription"] =
              item.bankCountryDescription;
            newForms[index]["bankAccountName"] = item.bankAccountName;
            newForms[index]["bankAddress"] = item.bankAddress;
            newForms[index]["bankBranchName"] = item.bankBranchName;
            newForms[index]["bankCurrency"] = item.bankCurrency;
            setBankDetails(newForms);
          }
        });
      }
    } else {
      // console.log(">> its empty", value);
      setBankDetails((prevState) => {
        const updatedForms = [...prevState];
        updatedForms[index] = {
          ...updatedForms[index],
          [key]: "", // Update the field with the given value (even if empty)
        };
        return updatedForms;
      });
    }
  };
  //bank end

  //Financial Turnover
  const [getFinancialTurnover,/* setFinancialTurnover*/] = useState([
    {
      id: 1,
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      financialTurnoverFileAttachment: "",
    },
    {
      id: 2,
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      financialTurnoverFileAttachment: "",
    },
    {
      id: 3,
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      financialTurnoverFileAttachment: "",
    },
  ]);
  // For Upload Success
  // const addFinancialTurnover = () => {
  //   const newDocument = {
  //     id: Date.now(),
  //     name: `Document ${getFinancialTurnover.length + 1}`,
  //     turnoverYear: "",
  //     documentNumber: "",
  //     valueTurnover: "",
  //     lakhsCroreTurnover: "",
  //   };
  //   setFinancialTurnover((prevData) => [...prevData, newDocument]);
  // };
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Transporter Registration</h2>
            <p className="subText">
              Register as a new trasnporter or Sub-Contractor with our Company
            </p>
            <hr />
            <Row className="mb-4">
              {/* <Col xs={12} md={2} lg={2} className="text-left">
                <button className="btnBack" onClick={() => navigateToLogin()}>
                  <i className="bi bi-arrow-return-left"></i> Go Back Login
                </button>
              </Col> */}
              {/* Next Button*/}
              <Col
                xs={12}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TR</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Transporter </span>
                      <span className="subHeaderTitle">Transporter Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transporter Name"
                          extraLabel="As per the trade license"
                          name="organisationName"
                          placeholder=""
                          value={formInputs.organisationName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.organisationName}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Lines 1 / Street"
                          name="address"
                          placeholder=""
                          value={formInputs.address || ""}
                          onChange={onInputChange}
                          error={validation.address}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          placeholder=""
                          value={formInputs.address2 || ""}
                          onChange={onInputChange}
                          error={validation.address2}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs.country}
                          getvalue={setDropdownData}
                          required={true}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          required={true}
                          // error={validation.state}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Sales Officer Name"
                          extraLabel=""
                          name="salesOfficerName"
                          code="salesOfficerCode"
                          description="salesOfficerDesc"
                          data={SalesOfficerData}
                          id="salesOfficerName"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.salesOfficerName}
                          error={validation.salesOfficerName}
                          getvalue={setDropdownData}
                          required={true}
                          // className="dropdownOption"
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          extraLabel="SAP Company Code"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCodeCode"
                          description="companyCodeDesc"
                          setValue={formInputs.companyCode || ""}
                          getvalue={setDropdownData}
                          onChange={onInputChange}
                          // error={validation.companyCode}
                          required={true}
                        />
                      </Col>
 <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="activeInactive"
                              >
                                Active/Inactive
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="activeInactive"
                                id="activeInactive"
                                checked={formInputs?.activeInactive || false}
                                onChange={(e) =>
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    activeInactive: e.target.checked,
                                  }))
                                }
                                // disabled={editMode}
                              />
                              <span className="ms-2">
                                {formInputs?.activeInactive
                                  ? "Active"
                                  : "Inactive"}
                              </span>
                            </div>
                          </Col>

                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              setValue={doc?.contactPosition}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              setValue={doc?.contactTitle}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>

                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4"
                                            />
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Document Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Document Type</span>
                      <span className="subHeaderTitle">Document Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issuing Authority
                                        </p>
                                      </Col> */}
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        {/* <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Issuing Authority"
                                            value={doc.issuingAuthority}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issuingAuthority",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col> */}
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BK</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle">Bank Information</span>
                      <span className="subHeaderTitle">
                        Bank Information (Please add all your Bank Accounts)
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                    <div className="d-flex justify-content-end  p-2 me-3">
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        // disabled={getDisabledStatus}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                      </div>
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={index}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              {/* <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span> */}
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Is the Company bank included on list?"
                                placeholder=""
                                data={dropdownOption}
                                id="bankNotListed"
                                iconClassName="dropdownIcon"
                                name="bankNotListed"
                                setValue={item?.bankNotListed || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="BankID"
                                placeholder=""
                                data={getBankDetailsData}
                                id="bankKey"
                                iconClassName="dropdownIcon"
                                name="bankKey"
                                setValue={item?.bankKey}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="BankID"
                                name="bankKey"
                                placeholder=""
                                value={item?.bankKey}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankKey",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank A/C Number"
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankAccountNumber",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                            label="Bank Name"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="bankName"
                                            iconClassName="dropdownIcon"
                                            name="bankName"
                                            setValue={item?.bankName || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}

                              <InputField
                                className="inputBox"
                                label="Bank Name"
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankBranchName",
                                    e.target.value
                                  )
                                }
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                            label="Bank Country"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="bankCountry"
                                            iconClassName="dropdownIcon"
                                            name="bankCountry"
                                            setValue={item?.bankCountry || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                              <InputField
                                className="inputBox"
                                label="Bank Country"
                                name="bankCountryDescription"
                                placeholder=""
                                value={item?.bankCountryDescription}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankCountryDescription",
                                    e.target.value
                                  )
                                }
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                            label="Branch Address"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="bankAddress"
                                            iconClassName="dropdownIcon"
                                            name="bankAddress"
                                            setValue={item?.bankAddress || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                              <InputField
                                className="inputBox"
                                label="Branch Address"
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankAddress",
                                    e.target.value
                                  )
                                }
                                // disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                            label="Preferred Currency"
                                            placeholder=""
                                            data={dropdownOption}
                                            id="preferredCurrency"
                                            iconClassName="dropdownIcon"
                                            name="preferredCurrency"
                                            setValue={item?.preferredCurrency || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                              <InputField
                                className="inputBox"
                                label="Preferred Currency"
                                name="bankCurrency"
                                placeholder=""
                                value={item?.bankCurrency}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankCurrency",
                                    e.target.value
                                  )
                                }
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name of Beneficiary"
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "AccountHolderName",
                                    e.target.value
                                  )
                                }
                                // disabled={getDisabledStatus}
                              />
                              {/* <ComboboxField
                                            label="Name of Beneficiary"
                                            placeholder=""
                                            extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                            data={dropdownOption}
                                            id="AccountHolderName"
                                            iconClassName="dropdownIcon"
                                            name="AccountHolderName"
                                            setValue={item?.AccountHolderName || ""}
                                            getvalue={setDropdownData}
                                            index={index}
                                            onChangeValue={handleChangeBankInfo}
                                            disabled={getDisabledStatus}
                                          /> */}
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Swift IFSC Code"
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Company letterhead"
                                  extraLabel="Upload the filled template on company letterhead , signed by authorized person with company seal "
                                  name="bankCompanyletterhead"
                                  placeholder=""
                                  value={item?.bankCompanyletterhead}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "bankCompanyletterhead",
                                      e.target.value
                                    )
                                  }
                                  // disabled={getDisabledStatus}
                                />
                                <div className="col-sm-10">
                                  <input
                                    className="form-control"
                                    type="file"
                                    id="formFile"
                                  />
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Confirmation letter"
                                  extraLabel="Do you have a Confirmation letter from the bank( mandatory for bank updates ) "
                                  name="bankConfirmationLetter"
                                  placeholder=""
                                  value={item?.bankConfirmationLetter}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "bankConfirmationLetter",
                                      e.target.value
                                    )
                                  }
                                  // disabled={getDisabledStatus}
                                />
                                <div className="col-sm-10">
                                  <input
                                    className="form-control"
                                    type="file"
                                    id="formFile"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col
          xs={12}
          md={{ span: 2, offset: 10 }}
          lg={{ span: 2, offset: 10 }}
          className="text-left"
        >
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default TransporterRegistration;
